module.exports = __webpack_public_path__ + "img/signature_sample_hant.4ff730b7.png";